export default "__VITE_PUBLIC_ASSET__facab281__"